import React, { useState } from 'react';

import { deviceKindIcon } from '../../utils/deviceCategory';
import { templateSignupImageUrl } from '../../utils/tagTemplate';

/**
 * ONE image vocabulary for every device/tag row (team tags list, Smart POS
 * wall): the kind glyph FIRST, replaced by the template's sign-up image once
 * it has loaded (Charles, 2026-10-06). The glyph is the loading state, not
 * an error state — a template without an image (404) simply never fires
 * onLoad, so there is nothing to undo and no broken-image flash.
 *
 * The image comes from the template via strike-payer's redirect, never from
 * the tag's one-shot actionText copy (stale after a re-upload, absent on
 * tags minted before the image existed — the Rinuccini S710, 2026-10-05).
 * Never avatar/topLogo: a device card wearing someone's profile photo is
 * noise, not signal.
 */
export default function DeviceImage({ tag, imgStyle, iconStyle }) {
  const [loaded, setLoaded] = useState(false);
  const src = templateSignupImageUrl(tag);
  const Glyph = deviceKindIcon(tag && tag.deviceKind);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      {!loaded && <Glyph style={iconStyle} />}
      {src && (
        <img
          src={src}
          alt=""
          data-testid="device-image"
          onLoad={() => setLoaded(true)}
          // Hidden, not display:none — the browser must still fetch it. Off
          // layout until loaded so the glyph alone sizes the slot.
          style={loaded
            ? imgStyle
            : { ...imgStyle, position: 'absolute', opacity: 0, pointerEvents: 'none' }}
        />
      )}
    </span>
  );
}
